import React, {Component} from "react";
import "./Header.css";

import utils from "utils";

export default class Header extends Component
{
	render()
	{
		const style =
		{
			marginBottom: utils.defaultValue(this.props.marginBottom, 35)
		};

		const blockStyle =
		{
			background: utils.defaultValue(this.props.color, "white")
		};

		const classes = utils.joinClasses(
		[
			"header",
			(this.props.small && "small"),
			this.props.className,
		]);

		return (
			<div className={classes} style={style}>
				<div className="block" style={blockStyle} />
				<div className="text">{this.props.title}</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Header/Header.js